<template>
  <div class="skill flex" v-if="skill">
    <svg
      class="radial-progress"
      :data-percentage="skill.percentage"
      viewBox="0 0 80 80"
    >
      <circle class="incomplete" cx="40" cy="40" r="35"></circle>
      <circle
        class="complete"
        cx="40"
        cy="40"
        r="35"
        style="stroke-dashoffset: 39.58406743523136"
      ></circle>
    </svg>
    <div class="flex flex-col">
      <span>{{ skill.skill }}</span>
      <i :class="skill.icon + ' icon big'"></i>
    </div>
  </div>
</template>
<script>
import { onMounted } from "vue";
import handleProgress from "./handleProgress";
export default {
  props: {
    skill: Object,
  },
  setup() {
    onMounted(() => handleProgress());
    return {
      handleProgress,
    };
  },
};
</script>
<style scoped>
.skill {
  position: relative;
}
.skill div {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
}
.skill span {
  text-transform: uppercase;
  letter-spacing: 2px;
}
/*** RADIAL PROGRESS ***/
/* Circumference = 2πr */
/* π = 3.1415926535898 */
/* r = 35 */

svg.radial-progress {
  height: auto;
  max-width: 200px;
  padding: 1em;
  transform: rotate(-90deg);
  width: 100%;
}

svg.radial-progress circle {
  fill: rgba(0, 0, 0, 0);
  stroke: #fff;
  stroke-dashoffset: 219.91148575129; /* Circumference */
  stroke-width: 3;
}

svg.radial-progress circle.incomplete {
  opacity: 0.25;
}

svg.radial-progress circle.complete {
  stroke-dasharray: 219.91148575129; /* Circumference */
}

/*** COLORS ***/
/* html */

.skill:nth-of-type(6n + 1) circle {
  stroke: #ff5733;
}
/* css3 */

.skill:nth-of-type(6n + 2) circle {
  stroke: #264de4;
}

/* js */

.skill:nth-of-type(6n + 3) circle {
  stroke: #f7df1e;
}

/* reactjs */

.skill:nth-of-type(6n + 4) circle {
  stroke: #00d8ff;
}

/* vuejs */

.skill:nth-of-type(6n + 5) circle {
  stroke: #42b883;
  /* stroke: #fddc32;*/
}
/* git */
.skill:nth-of-type(6n + 6) circle {
  stroke: #6cc644;
}
/* python */
.skill:nth-of-type(6n + 7) circle {
  stroke: #4584b6;
}
/* git */
.skill:nth-of-type(6n + 8) circle {
  stroke: #848484;
}
/* git */
.skill:nth-of-type(6n + 9) circle {
  stroke: #563d7c;
}
@media screen and (max-width: 520px) {
  #skills .skill span {
    display: none;
  }
}
</style>
